import {translate} from "./translations.ts";
interface TranslationKeys {
    [key: string]: string;
}

interface Translations {
    [lang: string]: TranslationKeys;
}
const translations: Translations = translate as unknown as Translations;
export function trans(key: string, replacements: Record<string, string> = {}): string {
    const lang = document.documentElement.lang;
    let translation = translations[lang][key] || key;
    Object.keys(replacements).forEach((replacement) => {
        translation = translation.replace(
            `:${replacement}`,
            replacements[replacement]
        );
    });

    return translation;
}

export default {
    install: (app: any, options: Record<string, string> = {}): void => {
        const t = (key: string, replacements: Record<string, string> = options): string => trans(key, replacements);
        app.config.globalProperties.trans = t;
        app.provide('trans', t);
    }
}
